import React from 'react'
import Home from "./Home/Home"

import { createBrowserRouter, RouterProvider } from "react-router-dom"
import Layout from './Layout/Layout'
import AboutUs from './AboutUs/AboutUs'
import Quotation from './Quotation/Quotation'
import Products from './Products/Products'
import ContactUs from './ContactUs/ContactUs'

export default function App() {

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      // errorElement:<Error/>,
      children: [
        {
          path: "",
          element: <Home />

        },
        {
          path: "about",
          element: <AboutUs />

        },
        {
          path: "products",
          element: <Products />
        },
        {
          path: "quickQuotation",
          element: <Quotation/>
        },
        {
          path: "contact",
          element: <ContactUs />
        },

      ]

    },


  ])

  return (
    < >

      <RouterProvider router={router} />

    </>
  )
}
